import { createFormState } from "redux-freeform";

const formConfig = {
  agencies: {
    validators: [],
  },
  serviceType: {
    validators: [],
  },
  paymentStatus: {
    validators: [],
  },
  paymentChannel: {
    validators: [],
  },
  paymentMethod: {
    validators: [],
  },
  paymentSource: {
    validators: [],
  },
  paymentMode: {
    validators: [],
  },
};

export const { reducer, mapStateToProps, mapDispatchToProps } =
  createFormState(formConfig);
